import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, ScrollRestoration } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { ServicesPage } from './pages/ServicesPage';
import { PricingPage } from './pages/PricingPage';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';
import { RefundPage } from './pages/RefundPage';
// ScrollToTop component to handle scroll restoration on route change
function ScrollToTop() {
  const {
    pathname
  } = window.location;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
export function App() {
  return <Router data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <Routes data-id="element-2">
        <Route path="/" element={<HomePage data-id="element-4" />} data-id="element-3" />
        <Route path="/services" element={<ServicesPage data-id="element-6" />} data-id="element-5" />
        <Route path="/pricing" element={<PricingPage data-id="element-8" />} data-id="element-7" />
        <Route path="/about" element={<AboutPage data-id="element-10" />} data-id="element-9" />
        <Route path="/contact" element={<ContactPage data-id="element-12" />} data-id="element-11" />
        <Route path="/privacy" element={<PrivacyPage data-id="element-14" />} data-id="element-13" />
        <Route path="/privacy-policy" element={<PrivacyPage data-id="element-16" />} data-id="element-15" />
        <Route path="/terms" element={<TermsPage data-id="element-18" />} data-id="element-17" />
        <Route path="/terms-and-conditions" element={<TermsPage data-id="element-20" />} data-id="element-19" />
        <Route path="/refund" element={<RefundPage data-id="element-22" />} data-id="element-21" />
        <Route path="/refund-policy" element={<RefundPage data-id="element-24" />} data-id="element-23" />
      </Routes>
    </Router>;
}